//edición de las lecturas de los contadores de una máquina en una fecha concreta
//
//
//lecturas euros:
//  cuando hay operadora y la semana está cerrada se muestran los valores quitando la parte de la operadora, mientras que cuando la semana aún no se ha cerrrado
//  se muestra el ingreso real de las máquinas y un multiplicador tal que el descuadre sea el mismo al quitar la parte de la operadora y poner el multiplicador real
//
//
//--------------------------------------------------------------------------------
//lecturas de euros máquinas con contadores solo de entradas y recaudación total
//  contador inicial
//  contador final
//  multiplicador: muestra un valor distinto dependiendo de si la semana está cerrada o no
//      semana cerrada: se muestra el valor de multiplicador que llega de la base de datos
//      semana no cerrada: se muestra el multiplicador / factor de la operadora    (de esta forma el descuadre sigue siendo el mismo si se muestra todos los ingresos o se quita la parte de la operadora )
//  único campo de texto de ingresos que se lee y modifica en la columna ingresos del primer contador
//      semana cerrada: se muestra el campo ingresos ( ingresosSinMult multiplicado por el factor de la operadora )
//      semana no cerrada: se muestra el campo ingresosSinMult ( lo que ha entrado el usuario)
//  único campo de texto de descuadre
//--------------------------------------------------------------------------------

//--------------------------------------------------------------------------------
//lecturas de euros máquinas con contadores solo de entradas y recaudación por contador
//  contador inicial
//  contador final
//  multiplicador: muestra un valor distinto dependiendo de si la semana está cerrada o no
//      semana cerrada: se muestra el valor de multiplicador que llega de la base de datos
//      semana no cerrada: se muestra el multiplicador / factor de la operadora    
// campo de texto de ingresos después de cada contador
//      semana cerrada: se muestra el campo ingresos ( ingresosSinMult multiplicado por el factor de la operadora )
//      semana no cerrada: se muestra el campo ingresosSinMult ( lo que ha entrado el usuario )
// campo de texto de descuadre 
//--------------------------------------------------------------------------------

//--------------------------------------------------------------------------------
//lecturas de euros máquinas con contadores de entradas y salidas
//  contador inicial entradas
//  contador final entradas
//  contador inicial salidas
//  contador final salidas
//  multiplicador: muestra un valor distinto dependiendo de si la semana está cerrada o no
//      semana cerrada: se muestra el valor de multiplicador que llega de la base de datos
//      semana no cerrada: se muestra el multiplicador / factor de la operadora    
// campo de texto de ingresos
//      semana cerrada: se muestra el campo ingresos ( ingresosSinMult multiplicado por el factor de la operadora )
//      semana no cerrada: se muestra el campo ingresosSinMult ( lo que ha entrado el usuario)
// campo de texto de descuadre después de cada contador que se calcula con la diferencia ingresos de entradas - salidas
//--------------------------------------------------------------------------------

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import update from 'immutability-helper';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { openDialog, hideDialog } from '../../actions/index';
import { getData, postData } from '../../dataLib';
import { modifyMaqArcade } from '../../actions/cierre_semanal_actions';

//components:
import FloatNumberFormatInput from '../../components/float_number_input_formatter';
import IntNumberFormatInput from '../../components/int_number_input_formatter';
import FloatNumberFormatText from '../../components/float_number_text_formatter';
import IntNumberFormatText from '../../components/int_number_text_formatter';

//maerial ui:
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Tooltip, Fade } from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';

// modifyMaqArcade(zonaId, total_euros, total_tickets, total_tokens)

const styles = theme => ({
    root: {
        margin: theme.spacing(2)
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'none',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    eurosTotalesContainer: {
        display: 'flex',
        width: 525,
        justifyContent: 'space-between',
    },
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 210,
        margin: '10px 10px 10px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    inputText: {
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    title: {
        margin: '25px 0px  10px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 100,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    maqTitle: {
        color: theme.palette.secondary.main
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    inputComentarios: {
        minWidth: 400,
        margin: '0px 10px',
        fontSize: 12,
    },
    divComentarios: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        alignItems: 'center',
        margin: theme.spacing(1),
    },
    header: {
        display: 'flex'
    },
    headerBox: {
        width: 85,
        margin: 0,
        fontSize: 12,
        fontWeight: 500,
        display: 'flex',
        justifyContent: 'center',
        border: '1px solid #dddddd',
        background: '#f9f9f9',
    },
    table: {
        display: 'inline-block',
        border: '1px solid #dddddd',
    },
    row: {
        display: 'flex',
    },
    rowTextCell: {
        width: 85,
        fontSize: 12,
        textAlign: 'right',
        border: '1px solid #dddddd',
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
    },
    rowEditableCell: {
        width: 85,
        border: '1px solid #dddddd',
    },
    inputCell: {
        textAlign: 'right',
        fontSize: 12,
        padding: 0
    },
    bottomBtn: {
        direction: 'rtl'
    }

});

class CierreSemanalLecturasArcadeDetail extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            euros: [],
            total_euros_ini: 0.0,
            total_euros: 0.0,
            tickets: [],
            total_tickets_ini: 0.0,
            total_tickets: 0.0,
            tokens: [],
            total_tokens_ini: 0.0,
            total_tokens: 0.0,
            regalos: [],
            total_regalos_ini: 0,
            total_regalos: 0,
            visas: [],
            total_visas_ini: 0,
            total_visas: 0,
            isLoading: true,
            isTipoB: this.props.tipoB,
            isMaquinaRegalos: this.props.tipoRegalo === 1
            
        };
    };

    componentDidMount = () => {
        this.getLecturas('euros');
        this.getLecturas('tickets');
        this.getLecturas('tokens');
        this.getLecturas('regalos');
        this.getLecturas('visas');
    };

    calculateTotal = (rows, iTipo) => {
        let total = 0.0;

        if (iTipo === 2 || iTipo === 4) {
            rows.forEach((r) => {
                total += parseFloat(r.contadorFin - r.contadorIni);
            });
        }
        else if (iTipo === 0) { //euros
            if (this.props.isSemanaCerrada) {
                rows.forEach((r) => {
                    total += parseFloat(r.ingresos);
                });
            }
            else {
                rows.forEach((r) => {
                    total += parseFloat(r.ingresosSinMult);
                });
            }
        }
        else {
            rows.forEach((r) => {
                total += parseFloat(r.ingresos);
            });
        }
        return total;

    };

    processRows = (rows, iTipo) => {

        return rows.map((row, index) => {

            console.log(row);

            if (iTipo === 2 || iTipo === 4) {

                let dif = row.contadorFin - row.contadorIni;
                if (Math.abs(dif) < 0.0001) dif = 0.0;
                return { ...row, descuadre: dif };

            }
            else if (iTipo === 1) {

                const ingresos = (index === 0) ? row.ingresos : 0;

                let dif = row.contadorFin - row.contadorIni;
                if (Math.abs(dif) < 0.0001) dif = 0.0;
                const t = parseFloat((dif * row.multiplicador).toFixed(2));
                const r = ingresos;
                let descuadre = r - t;
                if (Math.abs(descuadre) < 0.0001) descuadre = 0.0;
                return { ...row, ingresos: ingresos, descuadre: parseFloat((descuadre).toFixed(2)) };

            }
            else {

                // const ingresos = (index === 0) ? row.ingresos : 0;

                // let dif = row.contadorFin - row.contadorIni;
                // if (Math.abs(dif) < 0.0001) dif = 0.0;
                // const t = parseFloat((dif * row.multiplicador).toFixed(2));
                // const r = ingresos;
                // let descuadre = r - t;
                // if (Math.abs(descuadre) < 0.0001) descuadre = 0.0;
                // return { ...row, ingresos: ingresos, descuadre: parseFloat((descuadre).toFixed(2)) };

                //si hay operadora hay que usar el multiplicador real y los ingresos reales si la semana no está cerrada
                //let ingresos = (index === 0) ? row.ingresos : 0; //solo hay ingresos (el total de la máquina) en el primer contador

                let ingresos = 0;

                if (!this.state.isTipoB && !this.state.isMaquinaRegalos) ingresos = (index === 0) ? row.ingresos : 0; //solo hay ingresos (el total de la máquina) en el primer contador
                else ingresos = row.ingresos;

                let multiplicador = row.multiplicador;

                if (!this.props.isSemanaCerrada) {
                    const mult_reopa = this.props.recaudacionDiaria ? 1.0 : (this.props.centroDiaSelected.centro.reopa - 31162) / 100;

                    multiplicador = row.multiplicador / mult_reopa;
                    ingresos = row.ingresosSinMult;

                }

                let dif = 0.0;
                if(this.state.isTipoB) dif = row.contadorFin - row.contadorIni - row.controlContFin + row.controlContIni;
                else dif = row.contadorFin - row.contadorIni;
                if (Math.abs(dif) < 0.0001) dif = 0.0;
                const t = parseFloat((dif * multiplicador).toFixed(2));
                const r = ingresos;
                let descuadre = r - t;
                if (Math.abs(descuadre) < 0.0001) descuadre = 0.0;
                if (!this.state.isTipoB && !this.state.isMaquinaRegalos)
                    return { ...row, multiplicadorReal: multiplicador, ingresos: (index === 0) ? row.ingresos : 0, descuadre: parseFloat((descuadre).toFixed(2)) };
                else
                    return { ...row, multiplicadorReal: multiplicador, ingresos: row.ingresos, descuadre: parseFloat((descuadre).toFixed(2)) };

            }


        });

    };

    getLecturas = (tipo) => {
        let iTipo = -1;
        if (tipo === "euros") iTipo = 0;
        else if (tipo === "tickets") iTipo = 2;
        else if (tipo === "tokens") iTipo = 1;
        else if (tipo === "regalos") iTipo = 4;
        else if (tipo === "visas") iTipo = 5;

        getData(`VLecturas/LecturasPorMaquina?i_tipo=${iTipo}&maquina_id=${this.props.maquinaId}&centro_id=${this.props.centroDiaSelected.centro.id}&date=${this.props.fecha}`,
            (response) => {
                this.setState({
                    ...this.state,
                    //[tipo]: this.processRows(response.data.filter(r=>r.multiplicador !== 0 || iTipo === 2), iTipo),
                    [tipo]: this.processRows(response.data, iTipo),
                    ['total_' + tipo]: this.calculateTotal(response.data, iTipo), ['total_' + tipo + '_ini']: this.calculateTotal(response.data, iTipo),
                    isLoading: false
                })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching lecturas de ' + tipo + ' ' + error
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };

    //hace un update de lecturas, muestra un mensaje y actualiza el store
    updateLecturas = (open_next) => {

        const dataToUpload = this.state.euros.concat(this.state.tickets.concat(this.state.tokens.concat(this.state.regalos.concat(this.state.visas))));

        const mult = this.props.recaudacionDiaria ? 1.0 : ((this.props.centroDiaSelected.centro.reopa - 31162) / 100);

        dataToUpload.forEach(l => {
            if (l.iTipo === 0) { 
                l.usuarioId = this.props.user ? this.props.user.profile.sub : 0;
                l.ingresos = l.ingresosSinMult * mult;
            }
        });

        postData(
            'vlecturas/lecturas',
            (response) => {
                this.props.hideDialog();
                if (!open_next) {
                    this.props.openDialog('SimpleMessage', {
                        message: 'lecturas de contadores actualizadas'
                    }, uuidv4(), false, 'sm');
                }

                //const mult = this.props.recaudacionDiaria ? 1.0 : ((this.props.centroDiaSelected.centro.reopa - 31162) / 100);

                if (this.props.navigation.location === 'acc_cierre_semanal') {
                    this.props.modifyMaqArcade(
                        this.props.zonaId,
                        (this.state.total_euros * mult) - (this.state.total_euros_ini * mult),
                        this.state.total_euros - this.state.total_euros_ini,
                        this.state.total_tickets - this.state.total_tickets_ini,
                        this.state.total_tokens - this.state.total_tokens_ini,
                        this.state.total_regalos - this.state.total_regalos_ini,
                        this.state.total_visas - this.state.total_visas_ini
                    );
                }
                this.props.okHandler(this.props.maquinaId, this.state.total_euros * mult, this.state.total_euros, open_next);
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating arcade'
                }, uuidv4(), false, 'sm');
            },
            dataToUpload,
            this.props.user
        );
    };

    maquinaAnterior = () => {
        this.props.backHandler(this.props.maquinaId);
    }

    maquinaSiguiente = () => {
        this.props.nextHandler(this.props.maquinaId);
    }

    checkValues = (lectura) => {
        if (lectura.contadorIni > lectura.contadorFin) {
            return false;
        }
        return true;
    };

    modifyLectura = (lectura) => {

        let tipo = '';

        if (lectura.iTipo === 0) tipo = "euros";
        else if (lectura.iTipo === 2) tipo = "tickets";
        else if (lectura.iTipo === 1) tipo = "tokens";
        else if (lectura.iTipo === 4) tipo = "regalos";
        else if (lectura.iTipo === 5) tipo = "visas";

        var rows = this.state[tipo].map((row) => {
            if (row.id === lectura.id) {
                return { ...row, multiplicador: lectura.multiplicador, contadorFin: lectura.contadorFin, controlContFin: lectura.controlContFin, ingresos: lectura.ingresos, ingresosSinMult: lectura.ingresosSinMult, comentario: lectura.comentario };
                //return { ...row, contadorFin: lectura.contadorFin, comentario: lectura.comentario };
            }
            else return row;
        });
        this.setState({
            ...this.state,
            [tipo]: this.processRows(rows, lectura.iTipo),
            ['total_' + tipo]: this.calculateTotal(rows, lectura.iTipo)
        });
    };

    descuadreEuros = () => {
        const descuadreArray = this.state.euros.map(row => row.descuadre);

        const reduced = descuadreArray.length ? descuadreArray.reduce((a, b) => a + b) : 0;

        return reduced;
    };

    descuadreEurosRow = (index) => {

        return this.state.euros[index].descuadre;
    };

    descuadreTokens = () => {
        const descuadreArray = this.state.tokens.map(row => row.descuadre);

        const reduced = descuadreArray.length ? descuadreArray.reduce((a, b) => a + b) : 0;

        return reduced;
    };

    totalIngresosEuroTeoricos = () => {
        let total = 0.0;
        this.state.euros.forEach((row) => {
            total += parseFloat(((row.contadorFin - row.contadorIni) * row.multiplicador).toFixed(2));
        });
        return total;
    }

    ticketsXEuro = () => {
        //const totalIngresos = this.state.total_euros + this.state.total_tokens;
        const totalIngresos = this.totalIngresosEuroTeoricos();
        if (totalIngresos === 0) return 0;
        else return this.state.total_tickets / totalIngresos;
    }

    handleTotalEurosChange = (event) => {

        const mult = this.props.recaudacionDiaria ? 1.0 : ((this.props.centroDiaSelected.centro.reopa - 31162) / 100);
        this.modifyLectura({ ...this.state.euros[0], ingresos: parseFloat(event.target.value) * mult, ingresosSinMult: parseFloat(event.target.value) }); //se pone el total como ingresos de la primera fila
        //this.modifyLectura({ ...this.state.euros[0], ingresos: event.target.value });
    }

    handleTotalEurosRowChange = (event, index) => {
        const mult = (this.props.centroDiaSelected.centro.reopa - 31162) / 100;
        this.modifyLectura({ ...this.state.euros[index], ingresos: parseFloat(event.target.value) * mult, ingresosSinMult: parseFloat(event.target.value) }); //se pone el total como ingresos de la primera fila
    }

    handleTotalTicketsChange = (event) => {
        this.modifyLectura({ ...this.state.tickets[0], ingresos: event.target.value }); //se pone el total como ingresos de la primera fila
    }

    handleTotalTokensChange = (event) => {
        this.modifyLectura({ ...this.state.tokens[0], ingresos: event.target.value });
    }

    handleTotalRegalosChange = (event) => {
        this.modifyLectura({ ...this.state.regalos[0], ingresos: event.target.value });
    }

    handleTotalVisasChange = (event) => {
        this.modifyLectura({ ...this.state.visas[0], ingresos: event.target.value });
    }

    handleComentariosEurosChange = (event) => {
        this.modifyLectura({ ...this.state.euros[0], comentario: event.target.value });
    }

    handleComentariosEurosRowChange = (event, index) => {
        this.modifyLectura({ ...this.state.euros[index], comentario: event.target.value });
    }

    handleComentariosTicketsChange = (event) => {
        this.modifyLectura({ ...this.state.tickets[0], comentario: event.target.value });
    }

    handleComentariosTokensChange = (event) => {
        this.modifyLectura({ ...this.state.tokens[0], comentario: event.target.value });
    }

    handleComentariosRegalosChange = (event) => {
        this.modifyLectura({ ...this.state.regalos[0], comentario: event.target.value });
    }

    handleComentariosVisasChange = (event) => {
        this.modifyLectura({ ...this.state.visas[0], comentario: event.target.value });
    }

    handleGridRowsUpdated = (fromRow, toRow, updated, tipo) => {

        let rows = this.state[tipo];

        for (let i = fromRow; i <= toRow; i++) {

            let updatedRow = update(rows[i], { $merge: updated });
            this.modifyLectura(updatedRow);
        }

    };

    handleEurosContadorChange = (event, index) => {
        this.modifyLectura({ ...this.state.euros[index], contadorFin: event.target.value }); //no se modifican los ingresos, solo se modifican al cambiar el total
    }

    handleEurosContadorBlur = (event, index) => {
        if (this.state.euros[index].contadorIni > this.state.euros[index].contadorFin) {
            this.props.openDialog('SimpleMessage', { message: 'El contador actual no puede ser menor que el contador inicial' }, 'error-contador-fin', false, 'sm');
            this.modifyLectura({ ...this.state.euros[index], contadorFin: this.state.euros[index].contadorIni });
        }
    }

    handleEurosContadorSalidaChange = (event, index) => {
        this.modifyLectura({ ...this.state.euros[index], controlContFin: event.target.value }); //no se modifican los ingresos, solo se modifican al cambiar el total
    }

    handleEurosContadorSalidaBlur = (event, index) => {
        if (this.state.euros[index].controlContIni > this.state.euros[index].controlContFin) {
            this.props.openDialog('SimpleMessage', { message: 'El contador actual no puede ser menor que el contador inicial' }, 'error-contador-salida-fin', false, 'sm');
            this.modifyLectura({ ...this.state.euros[index], controlContFin: this.state.euros[index].controlContIni });
        }
    }

    renderEurosRow = (row, index) => {

        const { classes } = this.props;
        return (
            <div className={classes.row} key={index}>
                <div className={classes.rowTextCell}>{row.numOrden}</div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={this.props.isSemanaCerrada ? row.multiplicador : row.multiplicadorReal} /></div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        readOnly={this.props.isSemanaCerrada}
                        id={"contador-fin-euros-" + index}
                        value={this.state.euros[index].contadorFin}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleEurosContadorChange(event, index)}
                        onBlur={(event) => this.handleEurosContadorBlur(event, index)}
                    />
                </div>
            </div>
        )
    }


    renderEurosRows = () => {
        const { classes } = this.props;
        return (
            <div className={classes.table}>
                <div className={classes.header}>
                    <div className={classes.headerBox}>#</div>
                    <div className={classes.headerBox}>Multipl.</div>
                    <div className={classes.headerBox}>Cont. Ini</div>
                    <div className={classes.headerBox}>Cont. Fin</div>
                </div>
                {this.state.euros.map((row, index) => {
                    return this.renderEurosRow(row, index);
                })}
            </div>
        )
    }

    renderEurosRowPorContador = (row, index) => {

        const { classes } = this.props;
        return (

            <div className={classes.table}>
                <div className={classes.header}>
                    <div className={classes.headerBox}>#</div>
                    <div className={classes.headerBox}>Multipl.</div>
                    <div className={classes.headerBox}>Cont. Ini</div>
                    <div className={classes.headerBox}>Cont. Fin</div>
                    <div hidden={this.state.isMaquinaRegalos} className={classes.headerBox}>Cont. Salidas Ini</div>
                    <div hidden={this.state.isMaquinaRegalos} className={classes.headerBox}>Cont. Salidas Fin</div>
                </div>
                <div className={classes.row} key={index}>
                    <div className={classes.rowTextCell}>{row.numOrden}</div>
                    <div className={classes.rowTextCell}><FloatNumberFormatText value={this.props.isSemanaCerrada ? row.multiplicador : row.multiplicadorReal} /></div>
                    <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                    <div className={classes.rowTextCell}>
                        <InputBase
                            readOnly={this.props.isSemanaCerrada}
                            id={"contador-fin-euros-" + index}
                            value={this.state.euros[index].contadorFin}
                            inputComponent={IntNumberFormatInput}
                            classes={{ input: classes.inputCell }}
                            onChange={(event) => this.handleEurosContadorChange(event, index)}
                            onBlur={(event) => this.handleEurosContadorBlur(event, index)}
                        />
                    </div>
                    <div hidden={this.state.isMaquinaRegalos} className={classes.rowTextCell}><IntNumberFormatText value={row.controlContIni} /></div>
                    <div hidden={this.state.isMaquinaRegalos} className={classes.rowTextCell}>
                        <InputBase
                            readOnly={this.props.isSemanaCerrada}
                            id={"contador-fin-euros-salida-" + index}
                            value={this.state.euros[index].controlContFin}
                            inputComponent={IntNumberFormatInput}
                            classes={{ input: classes.inputCell }}
                            onChange={(event) => this.handleEurosContadorSalidaChange(event, index)}
                            onBlur={(event) => this.handleEurosContadorSalidaBlur(event, index)}
                        />
                    </div>
                </div>
                <div className={classes.eurosTotalesContainer}>
                    <div className={classes.total}>
                        <p style={{ margin: 0 }}>
                            {!this.props.isSemanaCerrada && this.props.centroDiaSelected.centro.reopa !== 31262 && !this.props.recaudacionDiaria ? 'Total Ingresos Reales' : 'Ingresos Reales'}
                        </p>
                        <Tooltip title={!this.props.isSemanaCerrada && this.props.centroDiaSelected.centro.reopa !== 31262 && !this.props.recaudacionDiaria ? 'Total Ingresos Reales' : 'Ingresos Reales'} TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                disabled={this.props.isSemanaCerrada}
                                id="total"
                                value={this.props.isSemanaCerrada ? this.state.euros[index].ingresos : this.state.euros[index].ingresosSinMult}
                                className={classes.input}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                variant="outlined"
                                onChange={(event) => this.handleTotalEurosRowChange(event, index)}
                            />
                        </Tooltip>
                    </div>

                    {!this.props.recaudacionDiaria ?
                        <div className={classes.total}>
                            <p style={{ margin: 0 }}>Total Descuadre</p>
                            <TextField
                                id="total"
                                disabled
                                value={this.descuadreEurosRow(index)}
                                className={classes.input}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                variant="outlined"
                            />
                        </div>
                        :
                        ''
                    }
                </div>

                <div className={classes.divComentarios}>
                    <p style={{ margin: 0 }}>Comentarios</p>
                    <Tooltip title="Comentarios" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                        <TextField
                            disabled={this.props.isSemanaCerrada}
                            id="comentarios"
                            value={this.state.euros[index].comentario}
                            className={classes.inputComentarios}
                            InputProps={{ classes: { input: classes.inputText } }}
                            variant="outlined"
                            onChange={(event) => this.handleComentariosEurosRowChange(event, index)}
                        />
                    </Tooltip>
                </div>

            </div>

        )
    }


    handleTicketsContadorChange = (event, index) => {
        this.modifyLectura({ ...this.state.tickets[index], contadorFin: event.target.value });
    }
    handleTicketsContadorBlur = (event, index) => {
        if (this.state.tickets[index].contadorIni > this.state.tickets[index].contadorFin) {
            this.props.openDialog('SimpleMessage', { message: 'El contador actual no puede ser menor que el contador inicial' }, 'error-contador-fin', false, 'sm');
            this.modifyLectura({ ...this.state.tickets[index], contadorFin: this.state.tickets[index].contadorIni });
        }
    }

    renderTicketsRow = (row, index) => {

        const { classes } = this.props;
        return (
            <div className={classes.row} key={index}>
                <div className={classes.rowTextCell}>{row.numOrden}</div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={row.multiplicador} /></div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        readOnly={this.props.isSemanaCerrada}
                        id={"contador-fin-tickets-" + index}
                        value={this.state.tickets[index].contadorFin}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleTicketsContadorChange(event, index)}
                        onBlur={(event) => this.handleTicketsContadorBlur(event, index)}
                    />
                </div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={row.descuadre} /></div>
            </div>
        )
    }

    renderTicketsRows = () => {
        const { classes } = this.props;
        return (
            <div className={classes.table}>
                <div className={classes.header}>
                    <div className={classes.headerBox}>#</div>
                    <div className={classes.headerBox}>Multipl.</div>
                    <div className={classes.headerBox}>Cont. Ini</div>
                    <div className={classes.headerBox}>Cont. Fin</div>
                    <div className={classes.headerBox}>Diferencia</div>
                </div>
                {this.state.tickets.map((row, index) => {
                    return this.renderTicketsRow(row, index);
                })}
            </div>
        )
    }


    handleTokensContadorChange = (event, index) => {
        this.modifyLectura({ ...this.state.tokens[index], contadorFin: event.target.value });
    }
    handleTokensContadorBlur = (event, index) => {
        if (this.state.tokens[index].contadorIni > this.state.tokens[index].contadorFin) {
            this.props.openDialog('SimpleMessage', { message: 'El contador actual no puede ser menor que el contador inicial' }, 'error-contador-fin', false, 'sm');
            this.modifyLectura({ ...this.state.tokens[index], contadorFin: this.state.tokens[index].contadorIni });
        }
    }

    renderTokensRow = (row, index) => {

        const { classes } = this.props;
        return (
            <div className={classes.row} key={index}>
                <div className={classes.rowTextCell}>{row.numOrden}</div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={row.multiplicador} /></div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        readOnly={this.props.isSemanaCerrada}
                        id={"contador-fin-tokens-" + index}
                        value={this.state.tokens[index].contadorFin}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleTokensContadorChange(event, index)}
                        onBlur={(event) => this.handleTokensContadorBlur(event, index)}
                    />
                </div>
            </div>
        )
    }

    renderTokensRows = () => {
        const { classes } = this.props;
        return (
            <div className={classes.table}>
                <div className={classes.header}>
                    <div className={classes.headerBox}>#</div>
                    <div className={classes.headerBox}>Multipl.</div>
                    <div className={classes.headerBox}>Cont. Ini</div>
                    <div className={classes.headerBox}>Cont. Fin</div>
                </div>
                {this.state.tokens.map((row, index) => {
                    return this.renderTokensRow(row, index);
                })}
            </div>
        )
    }

    handleRegalosContadorChange = (event, index) => {
        this.modifyLectura({ ...this.state.regalos[index], contadorFin: event.target.value });
    }
    handleRegalosContadorBlur = (event, index) => {
        if (this.state.regalos[index].contadorIni > this.state.regalos[index].contadorFin) {
            this.props.openDialog('SimpleMessage', { message: 'El contador actual no puede ser menor que el contador inicial' }, 'error-contador-fin', false, 'sm');
            this.modifyLectura({ ...this.state.regalos[index], contadorFin: this.state.regalos[index].contadorIni });
        }
    }

    renderRegalosRow = (row, index) => {

        const { classes } = this.props;
        return (
            <div className={classes.row} key={index}>
                <div className={classes.rowTextCell}>{row.numOrden}</div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={row.multiplicador} /></div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        readOnly={this.props.isSemanaCerrada}
                        id={"contador-fin-regalos-" + index}
                        value={this.state.regalos[index].contadorFin}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleRegalosContadorChange(event, index)}
                        onBlur={(event) => this.handleRegalosContadorBlur(event, index)}
                    />
                </div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={row.descuadre} /></div>
            </div>
        )
    }

    renderRegalosRows = () => {
        const { classes } = this.props;
        return (
            <div className={classes.table}>
                <div className={classes.header}>
                    <div className={classes.headerBox}>#</div>
                    <div className={classes.headerBox}>Multipl.</div>
                    <div className={classes.headerBox}>Cont. Ini</div>
                    <div className={classes.headerBox}>Cont. Fin</div>
                    <div className={classes.headerBox}>Diferencia</div>
                </div>
                {this.state.regalos.map((row, index) => {
                    return this.renderRegalosRow(row, index);
                })}
            </div>
        )
    }

   
    handleVisasContadorChange = (event, index) => {
        this.modifyLectura({ ...this.state.visas[index], contadorFin: event.target.value });
    }
    handleVisasContadorBlur = (event, index) => {
        if (this.state.visas[index].contadorIni > this.state.visas[index].contadorFin) {
            this.props.openDialog('SimpleMessage', { message: 'El contador actual no puede ser menor que el contador inicial' }, 'error-contador-fin', false, 'sm');
            this.modifyLectura({ ...this.state.visas[index], contadorFin: this.state.visas[index].contadorIni });
        }
    }

    renderVisasRow = (row, index) => {

        const { classes } = this.props;
        return (
            <div className={classes.row} key={index}>
                <div className={classes.rowTextCell}>{row.numOrden}</div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={row.multiplicador} /></div>
                <div className={classes.rowTextCell}><IntNumberFormatText value={row.contadorIni} /></div>
                <div className={classes.rowTextCell}>
                    <InputBase
                        readOnly={this.props.isSemanaCerrada}
                        id={"contador-fin-visas-" + index}
                        value={this.state.visas[index].contadorFin}
                        inputComponent={IntNumberFormatInput}
                        classes={{ input: classes.inputCell }}
                        onChange={(event) => this.handleVisasContadorChange(event, index)}
                        onBlur={(event) => this.handleVisasContadorBlur(event, index)}
                    />
                </div>
                <div className={classes.rowTextCell}><FloatNumberFormatText value={row.descuadre} /></div>
            </div>
        )
    }

    renderVisasRows = () => {
        const { classes } = this.props;
        return (
            <div className={classes.table}>
                <div className={classes.header}>
                    <div className={classes.headerBox}>#</div>
                    <div className={classes.headerBox}>Multipl.</div>
                    <div className={classes.headerBox}>Cont. Ini</div>
                    <div className={classes.headerBox}>Cont. Fin</div>
                    <div className={classes.headerBox}>Diferencia</div>
                </div>
                {this.state.visas.map((row, index) => {
                    return this.renderVisasRow(row, index);
                })}
            </div>
        )
    }


    renderEuros = () => {

        const { classes } = this.props;
        return (
            <div>
                {!this.props.recaudacionDiaria ?
                    <div>
                        <Typography variant="h6" className={classes.title} color={'primary'}>Contadores €</Typography>
                        {this.renderEurosRows()}
                    </div>
                    :
                    <Typography variant="h6" className={classes.title} color={'primary'}>Recaudación €</Typography>
                }

                <div className={classes.eurosTotalesContainer}>
                    <div className={classes.total}>
                        <p style={{ margin: 0 }}>
                            {!this.props.isSemanaCerrada && this.props.centroDiaSelected.centro.reopa !== 31262 && !this.props.recaudacionDiaria ? 'Total Ingresos Reales' : 'Ingresos Reales'}
                        </p>
                        <Tooltip title={!this.props.isSemanaCerrada && this.props.centroDiaSelected.centro.reopa !== 31262 && !this.props.recaudacionDiaria ? 'Total Ingresos Reales' : 'Ingresos Reales'} TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                disabled={this.props.isSemanaCerrada}
                                id="total"
                                value={this.state.total_euros}
                                className={classes.input}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                variant="outlined"
                                onChange={(event) => this.handleTotalEurosChange(event)}
                            />
                        </Tooltip>
                    </div>

                    {!this.props.recaudacionDiaria ?
                        <div className={classes.total}>
                            <p style={{ margin: 0 }}>Total Descuadre</p>
                            <TextField
                                id="total"
                                disabled
                                value={this.descuadreEuros()}
                                className={classes.input}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                variant="outlined"
                            />
                        </div>
                        :
                        ''
                    }
                </div>

                <div className={classes.divComentarios}>
                    <p style={{ margin: 0 }}>Comentarios</p>
                    <Tooltip title="Comentarios" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                        <TextField
                            disabled={this.props.isSemanaCerrada}
                            id="comentarios"
                            value={this.state.euros[0].comentario}
                            className={classes.inputComentarios}
                            InputProps={{ classes: { input: classes.inputText } }}
                            variant="outlined"
                            onChange={(event) => this.handleComentariosEurosChange(event)}
                        />
                    </Tooltip>
                </div>


            </div>
        )

    }

    renderEurosPorContador = () => {

        const { classes } = this.props;
        return (
            <div>
                {this.state.euros.map((row, index) => {
                    return this.renderEurosRowPorContador(row, index);
                })}
            </div>
        )

    }


    render() {
        const { classes } = this.props;

        if (this.props.maquinaId === undefined) {
            return (<div></div>);
        }

        return (
            <div className={classes.root}>

                {this.state.isLoading ?
                    <div className={classes.spinnerContainer}>
                        <CircularProgress className={classes.spinner} color="primary" />
                    </div>

                    : <div>
                        <Typography className={classes.maqTitle} variant='h4'>{this.props.maquinaDescr + ' (' + this.props.maquinaRegInterno + ')'}</Typography>
                        {this.state.euros.length ?
                            <div>
                                {(this.state.isTipoB || this.state.isMaquinaRegalos) ? this.renderEurosPorContador() : this.renderEuros()}

                            </div>

                            : ''}


                        {this.state.tickets.length && !this.props.recaudacionDiaria ?
                            <div>
                                <Typography variant="h6" className={classes.title} color={'primary'}>Contadores tickets</Typography>
                                {this.renderTicketsRows()}
                                <div className={classes.eurosTotalesContainer}>
                                    <div className={classes.total}>
                                        <p style={{ margin: 0 }}>Total</p>
                                        <Tooltip title="Total tickets" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                                            <TextField
                                                disabled
                                                id="total"
                                                value={this.state.total_tickets}
                                                className={classes.input}
                                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                                variant="outlined"
                                                onChange={(event) => this.handleTotalTicketsChange(event)}
                                            />
                                        </Tooltip>
                                    </div>
                                    <div className={classes.total}>
                                        <p style={{ margin: 0 }}>Tickets x Euro</p>
                                        <TextField
                                            id="ticketsxeuro"
                                            disabled
                                            value={this.ticketsXEuro()}
                                            className={classes.input}
                                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                            variant="outlined"
                                        />
                                    </div>
                                </div>
                                <div className={classes.divComentarios}>
                                    <p style={{ margin: 0 }}>Comentarios</p>

                                    <TextField
                                        disabled={this.props.isSemanaCerrada}
                                        id="total"
                                        value={this.state.tickets[0].comentario}
                                        className={classes.inputComentarios}
                                        InputProps={{ classes: { input: classes.inputText } }}
                                        variant="outlined"
                                        onChange={(event) => this.handleComentariosTicketsChange(event)}
                                    />

                                </div>
                            </div> : ''}


                        {this.state.tokens.length && !this.props.recaudacionDiaria ?
                            <div>
                                <Typography variant="h6" className={classes.title} color={'primary'}>Contadores tokens</Typography>
                                {this.renderTokensRows()}

                                <div className={classes.eurosTotalesContainer}>
                                    <div className={classes.total}>
                                        <p style={{ margin: 0 }}>Total Ingresos</p>
                                        <Tooltip title="Total ingresos reales en Tokens" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                                            <TextField
                                                disabled={this.props.isSemanaCerrada}
                                                id="total"
                                                value={this.state.total_tokens}
                                                className={classes.input}
                                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                                variant="outlined"
                                                onChange={(event) => this.handleTotalTokensChange(event)}
                                            />
                                        </Tooltip>
                                    </div>

                                    <div className={classes.total}>
                                        <p style={{ margin: 0 }}>Total Descuadre</p>
                                        <TextField
                                            id="total"
                                            disabled
                                            value={this.descuadreTokens()}
                                            className={classes.input}
                                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                            variant="outlined"
                                        />
                                    </div>
                                </div>
                                <div className={classes.divComentarios}>
                                    <p style={{ margin: 0 }}>Comentarios</p>
                                    <TextField
                                        disabled={this.props.isSemanaCerrada}
                                        id="total"
                                        value={this.state.tokens[0].comentario}
                                        className={classes.inputComentarios}
                                        InputProps={{ classes: { input: classes.inputText } }}
                                        variant="outlined"
                                        onChange={(event) => this.handleComentariosTokensChange(event)}
                                    />
                                </div>
                            </div> : ''}

                        {this.state.regalos.length && !this.props.recaudacionDiaria ?
                            <div>
                                <Typography variant="h6" className={classes.title} color={'primary'}>Contadores regalos</Typography>
                                {this.renderRegalosRows()}
                                <div className={classes.eurosTotalesContainer}>
                                    <div className={classes.total}>
                                        <p style={{ margin: 0 }}>Total</p>
                                        <Tooltip title="Total regalos" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                                            <TextField
                                                disabled
                                                id="total"
                                                value={this.state.total_regalos}
                                                className={classes.input}
                                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                                variant="outlined"
                                                onChange={(event) => this.handleTotalRegalosChange(event)}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className={classes.divComentarios}>
                                    <p style={{ margin: 0 }}>Comentarios</p>

                                    <TextField
                                        disabled={this.props.isSemanaCerrada}
                                        id="total"
                                        value={this.state.regalos[0].comentario}
                                        className={classes.inputComentarios}
                                        InputProps={{ classes: { input: classes.inputText } }}
                                        variant="outlined"
                                        onChange={(event) => this.handleComentariosRegalosChange(event)}
                                    />

                                </div>
                            </div> : ''}

                        {this.state.visas.length && !this.props.recaudacionDiaria ?
                            <div>
                                <Typography variant="h6" className={classes.title} color={'primary'}>Contadores VISAs</Typography>
                                {this.renderVisasRows()}
                                <div className={classes.eurosTotalesContainer}>
                                    <div className={classes.total}>
                                        <p style={{ margin: 0 }}>Total</p>
                                        <Tooltip title="Total visas" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                                            <TextField
                                                disabled={this.props.isSemanaCerrada}
                                                id="total"
                                                value={this.state.total_visas}
                                                className={classes.input}
                                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                                variant="outlined"
                                                onChange={(event) => this.handleTotalVisasChange(event)}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className={classes.divComentarios}>
                                    <p style={{ margin: 0 }}>Comentarios</p>

                                    <TextField
                                        disabled={this.props.isSemanaCerrada}
                                        id="total"
                                        value={this.state.visas[0].comentario}
                                        className={classes.inputComentarios}
                                        InputProps={{ classes: { input: classes.inputText } }}
                                        variant="outlined"
                                        onChange={(event) => this.handleComentariosVisasChange(event)}
                                    />

                                </div>
                            </div> : ''}
                    </div>
                }


                <div className={classes.bottomBtn}>
                    {!this.props.isSemanaCerrada ? <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.updateLecturas(true) }}>Guardar y siguiente</Button> :
                        <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.maquinaSiguiente() }}>Siguiente</Button>}
                    {!this.props.isSemanaCerrada ? <Button variant="contained" color="primary" className={classes.button} onClick={() => { this.updateLecturas(false) }}>Guardar</Button> : ''}
                    {<Button variant="contained" color="primary" className={classes.button} onClick={() => { this.maquinaAnterior() }}>Anterior</Button>}
                    {this.props.isDialog ? <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Cerrar</Button> : ''}
                </div>

            </div>
        );
    };
};


CierreSemanalLecturasArcadeDetail.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    maquinaDescr: PropTypes.string.isRequired,

    //dispatch
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,

    maquinaId: PropTypes.number.isRequired,
    zonaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    backHandler: PropTypes.func.isRequired,
    nextHandler: PropTypes.func.isRequired,
    recaudacionDiaria: PropTypes.bool.isRequired,
    fecha: PropTypes.object

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada,
        navigation: state.navigation,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
        openDialog,
        modifyMaqArcade,
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalLecturasArcadeDetail));